/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

import { BreadcrumbVariant, StyledBreadcrumbProps } from './index';

/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = css`
    text-align: left;

    span {
        ${theme.typography.body_small}
    }

    .breadcrumb-mobile {
        display: none;
    }

    ${smallTablet(css`
        .breadcrumb-link-list {
            display: none;
        }
        .breadcrumb-mobile {
            display: inline-flex;
            align-items: stretch;
            padding: 0.3rem var(--layout-spacing-8) 0.3rem
                var(--layout-spacing-4);
            text-decoration: none;
            backdrop-filter: blur(1.6rem);
            border-radius: 0.4rem;
            background: var(--colors-overlay-dark);

            span {
                color: var(--colors-text-secondary);
                min-height: 2rem;
            }

            .icon {
                font-size: 1.2rem;
                width: 1.2rem;
                height: 1.2rem;
            }
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * Desktop variant styles for the breadcrumb component
 *
 * @param {StyledBreadcrumbProps} props The breadcrumb properties object
 * @param {BreadcrumbVariant} props.desktopVariant The variant of the component at desktop viewports
 * */
const desktopVariantStyles = ({ desktopVariant }: StyledBreadcrumbProps) => {
    switch (desktopVariant) {
        case BreadcrumbVariant.DARK:
            return css`
                .breadcrumb-link-list {
                    a,
                    span,
                    li::after {
                        color: var(--colors-text-inverse);
                    }
                }
            `;

        case BreadcrumbVariant.LIGHT:
        default:
            return css`
                .breadcrumb-link-list {
                    a,
                    span,
                    li::after {
                        color: var(--colors-text-secondary);
                    }
                }
            `;
    }
};

/**
 * Mobile variant styles for the breadcrumb component
 *
 * @param {StyledBreadcrumbProps} props The breadcrumb properties object
 * @param {BreadcrumbVariant} props.mobileVariant The variant of the component at desktop viewports
 * */
const mobileVariantStyles = ({ mobileVariant }: StyledBreadcrumbProps) => {
    switch (mobileVariant) {
        case BreadcrumbVariant.DARK:
            return smallTablet(css`
                .breadcrumb-mobile {
                    background: var(--colors-overlay-light);
                    span {
                        color: var(--colors-text-inverse);
                    }
                    .icon svg {
                        fill: var(--colors-text-inverse);
                    }
                }
            `);

        case BreadcrumbVariant.LIGHT:
        default:
            return css``;
    }
};

export const styles = (props: StyledBreadcrumbProps) => css`
    ${baseStyles}
    ${desktopVariantStyles(props)}
    ${mobileVariantStyles(props)}
`;
